import { render, staticRenderFns } from "./ProjectCompanies.vue?vue&type=template&id=6742bf38&scoped=true"
import script from "./ProjectCompanies.vue?vue&type=script&lang=js"
export * from "./ProjectCompanies.vue?vue&type=script&lang=js"
import style0 from "./ProjectCompanies.vue?vue&type=style&index=0&id=6742bf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742bf38",
  null
  
)

export default component.exports